module.exports = __webpack_public_path__ + "img/bana_3kl.9e84c5b5.jpg";